import { Component, Input, signal } from '@angular/core';

/**
 * Tenant Logo Component
 *
 * Displays tenant logo with graceful fallback to text.
 * Handles image loading errors.
 */
@Component({
  selector: 'app-tenant-logo',
  standalone: true,
  imports: [],
  template: `
    <div class="tenant-logo-container" [class.align-start]="align === 'start'">
      @if (logoUrl && !loadError()) {
        <img
          [src]="logoUrl"
          [alt]="altText"
          class="tenant-logo-image"
          (error)="onLoadError()"
        />
      } @else if (tenantName) {
        <div class="tenant-logo-fallback">
          <span class="logo-text-primary">{{ tenantName }}</span>
        </div>
      }
    </div>
  `,
  styles: [`
    .tenant-logo-container {
      display: flex;
      justify-content: center;
      align-items: center;
    }

    .tenant-logo-container.align-start {
      justify-content: flex-start;
    }

    .tenant-logo-image {
      max-width: 200px;
      max-height: 100px;
      object-fit: contain;
    }

    .tenant-logo-fallback {
      display: flex;
      flex-direction: column;
      align-items: center;
      gap: var(--aida-ref-spacing-50);
    }

    .logo-text-primary {
      font-size: var(--aida-ref-font-size-700);
      font-weight: var(--aida-ref-font-weight-bold);
      color: #1E3A4C;
      font-family: var(--aida-ref-font-family-text);
    }

    .logo-text-secondary {
      font-size: var(--aida-ref-font-size-300);
      color: var(--aida-colour-text-secondary);
    }

    @media (max-width: 600px) {
      .tenant-logo-image {
        max-width: 150px;
        max-height: 60px;
      }

      .logo-text-primary {
        font-size: var(--aida-ref-font-size-600);
      }
    }
  `],
})
export class TenantLogoComponent {
  @Input() logoUrl?: string | null;
  @Input() tenantName?: string | null;
  @Input() altText = 'Company Logo';
  @Input() align: 'start' | 'center' = 'center';

  loadError = signal(false);

  onLoadError(): void {
    this.loadError.set(true);
  }
}
